import { withAppInsights } from '@exxonmobil/uit-uda-ui-components-lib';
import { RevisionCode } from 'models/revisionCodes';

export const getRevisionCodes = async (): Promise<RevisionCode[]> => {
  return withAppInsights(async () => {
    const mockRevisionCodes: RevisionCode[] = [
      {
        code: 'RevCode0',
        startDate: '2022-01-01',
        endDate: '2022-02-15'
      },
      {
        code: 'RevCode1',
        startDate: '2023-01-05',
        endDate: '2023-02-10'
      },
      {
        code: 'RevCode2',
        startDate: '2023-02-05',
        endDate: '2023-02-09'
      },
      {
        code: 'RevCode3',
        startDate: '2023-03-15',
        endDate: '2023-05-08'
      }
    ];

    return new Promise((resolve) =>
      // eslint-disable-next-line no-promise-executor-return
      setTimeout(() => resolve(mockRevisionCodes), 4500)
    );
  });
};
